let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("4VHZG")]).then(() => parcelRequire('iPGiI'));